<app-alert [alertType]="alertType"  (closeClick)="closeClick.emit()">
  <span>{{ text | translate }}</span>

  <app-new-button
    data-test-id="undo-button"
    class="h-8 w-14.5 ml-3"
    [type]="'primary'"
    (click)="onUndoClick()"
  >
    {{ buildTranslationKey('undoBtn') | translate }}
  </app-new-button>
</app-alert>
